import React from 'react';

const NumberToWords = (num) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const convert = (n) => {
        if (n === 0) return '';
        if (n < 10) return units[n];
        if (n === 10) return tens[1];
        if (n < 20) return teens[n - 11];
        if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + units[n % 10] : '');
        if (n < 1000) return units[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + convert(n % 100) : '');
        if (n < 100000) return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 !== 0 ? ' ' + convert(n % 1000) : '');
        if (n < 10000000) return convert(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 !== 0 ? ' ' + convert(n % 100000) : '');
        return 'Number too large';
    };
    if (num === 0) return 'Zero';
    return convert(num).trim();
};

const AmountInWords = ({ amount }) => {
    const [rupees, paise] = parseFloat(amount || 0).toFixed(2).split('.');
    return (
        <div style={{ fontSize: '13px', padding: '2px 4px' }}>
            <strong>Rupees {NumberToWords(parseInt(rupees))} Only</strong>
            {paise !== '00' && <span> and {NumberToWords(parseInt(paise))} Paise</span>}
        </div>
    );
};

const PurchaseOrderBill = ({ labelData }) => {
    const border = '1px solid black';
    const cellR = { fontSize: '12px', borderLeft: border, borderRight: border, textAlign: 'right', padding: '6px 4px', height: '32px' };
    const cellL = { fontSize: '12px', borderLeft: border, borderRight: border, textAlign: 'left', padding: '6px 4px', height: '32px' };

    if (!labelData?.PurchaseOrder) return null;

    const header = labelData.PurchaseOrder;
    const items = labelData.PurchaseOrderDetails || [];

    return (
        <div style={{ width: '100%', maxWidth: '100%', margin: 'auto', fontFamily: 'Arial, sans-serif', border, padding: 0, boxSizing: 'border-box' }}>

            {/* Company Header */}
            <div style={{ textAlign: 'center', borderBottom: border, padding: '6px', lineHeight: '1.4' }}>
                <h3 style={{ margin: '2px', fontWeight: 'bold' }}>{header.CompanyName}</h3>
                <div style={{ fontSize: '12px' }}>
                    {header.CompanyAddressLine}<br />
                    {header.CompanyContactNumber1}
                </div>
                <div style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '4px' }}>
                    GST NO : {header.CompanyGSTNumber} &nbsp;&nbsp; State : {header.BranchStateName} - {header.BranchStateCode}
                </div>
            </div>

            {/* Title Row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: border, padding: '8px 10px', fontSize: '13px', position: 'relative' }}>
                <div>Order No : {header.BillNumber}</div>
                <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', fontWeight: 'bold', fontSize: '15px', whiteSpace: 'nowrap' }}>
                    PURCHASE ORDER
                </div>
                <div>Date : {new Date(header.BillDate).toLocaleDateString('en-GB')}</div>
            </div>

            {/* Supplier Info */}
            <div style={{ display: 'flex', borderBottom: border, fontSize: '12px' }}>
                <div style={{ flex: 2, borderRight: border, padding: '5px' }}>
                    <strong>Supplier Name &amp; Address</strong><br />
                    {header.SupplierName}<br />
                    {header.SupplierAddress}<br />
                    {header.SupplierContactNumber}
                </div>
                <div style={{ flex: 1, padding: '5px' }}>
                    <div>GST NO : {header.SupplierGSTNumber || header.GSTNumber}</div>
                    <div>Invoice Type : {header.InvoiceTypeName}</div>
                </div>
            </div>

            {/* Items Table */}
            <table style={{ borderCollapse: 'collapse', width: '100%', borderLeft: border, borderRight: border }}>
                <thead>
                    <tr>
                        <th rowSpan="2" style={{ width: '5%', fontSize: '11px', border }}>HSN</th>
                        <th rowSpan="2" style={{ width: '22%', fontSize: '11px', border }}>Description</th>
                        <th rowSpan="2" style={{ width: '7%', fontSize: '11px', border }}>Unit Price</th>
                        <th rowSpan="2" style={{ width: '7%', fontSize: '11px', border }}>Dis Amt</th>
                        <th rowSpan="2" style={{ width: '5%', fontSize: '11px', border }}>Bal Qty</th>
                        <th rowSpan="2" style={{ width: '5%', fontSize: '11px', border }}>Qty</th>
                        <th rowSpan="2" style={{ width: '8%', fontSize: '11px', border }}>Taxable Amt</th>
                        <th colSpan="2" style={{ fontSize: '11px', border }}>CGST</th>
                        <th colSpan="2" style={{ fontSize: '11px', border }}>SGST</th>
                        <th colSpan="2" style={{ fontSize: '11px', border }}>IGST</th>
                        <th rowSpan="2" style={{ width: '10%', fontSize: '11px', border }}>Total</th>
                    </tr>
                    <tr>
                        {['%', 'Amt', '%', 'Amt', '%', 'Amt'].map((h, i) => (
                            <th key={i} style={{ width: i % 2 === 0 ? '3%' : '5%', fontSize: '11px', border }}>{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, idx) => (
                        <tr key={idx} style={{ height: '32px' }}>
                            <td style={cellL}>{item.HSNCode || '\u00A0'}</td>
                            <td style={cellL}>{item.ItemName || '\u00A0'}</td>
                            <td style={cellR}>{item.Rate ? parseFloat(item.Rate).toFixed(2) : '\u00A0'}</td>
                            <td style={cellR}>{item.DiscountAmount ? parseFloat(item.DiscountAmount).toFixed(2) : '\u00A0'}</td>
                            <td style={cellR}>{item.BalanceQuantity || '\u00A0'}</td>
                            <td style={cellR}>{item.Quantity || '\u00A0'}</td>
                            <td style={cellR}>{item.TaxableAmount ? parseFloat(item.TaxableAmount).toFixed(2) : '\u00A0'}</td>
                            <td style={cellR}>{item.GSTRate ? (parseFloat(item.GSTRate) / 2).toFixed(1) : '\u00A0'}</td>
                            <td style={cellR}>{item.CGSTAmount ? parseFloat(item.CGSTAmount).toFixed(2) : '\u00A0'}</td>
                            <td style={cellR}>{item.GSTRate ? (parseFloat(item.GSTRate) / 2).toFixed(1) : '\u00A0'}</td>
                            <td style={cellR}>{item.SGSTAmount ? parseFloat(item.SGSTAmount).toFixed(2) : '\u00A0'}</td>
                            <td style={cellR}>{item.GSTRate ? parseFloat(item.GSTRate).toFixed(1) : '\u00A0'}</td>
                            <td style={cellR}>{item.IGSTAmount ? parseFloat(item.IGSTAmount).toFixed(2) : '\u00A0'}</td>
                            <td style={cellR}>{item.TotalAmount ? parseFloat(item.TotalAmount).toFixed(2) : '\u00A0'}</td>
                        </tr>
                    ))}

                    {/* Blank rows */}
                    {[...Array(5)].map((_, i) => (
                        <tr key={`blank-${i}`}>
                            {Array(13).fill(null).map((_, j) => (
                                <td key={j} style={{ borderLeft: border, borderRight: border, height: '32px', padding: '6px 4px' }}>&nbsp;</td>
                            ))}
                        </tr>
                    ))}

                    {/* Total Row */}
                    <tr style={{ fontWeight: 'bold', fontSize: '12px', backgroundColor: '#f2f2f2' }}>
                        <td colSpan="5" style={{ textAlign: 'center', border }}>Total</td>
                        <td style={{ textAlign: 'right', border }}>{items.reduce((s, i) => s + (parseFloat(i.Quantity) || 0), 0)}</td>
                        <td style={{ textAlign: 'right', border }}>{items.reduce((s, i) => s + (parseFloat(i.TaxableAmount) || 0), 0).toFixed(2)}</td>
                        <td></td>
                        <td style={{ textAlign: 'right', border }}>{items.reduce((s, i) => s + (parseFloat(i.CGSTAmount) || 0), 0).toFixed(2)}</td>
                        <td></td>
                        <td style={{ textAlign: 'right', border }}>{items.reduce((s, i) => s + (parseFloat(i.SGSTAmount) || 0), 0).toFixed(2)}</td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'right', border }}>{items.reduce((s, i) => s + (parseFloat(i.TotalAmount) || 0), 0).toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>

            {/* Bottom Section */}
            <div style={{ display: 'flex', borderTop: border, fontSize: '12px' }}>
                {/* Remarks */}
                <div style={{ flex: 2, borderRight: border, padding: '5px' }}>
                    {header.Remarks && <><strong>Remarks:</strong> {header.Remarks}</>}
                </div>

                {/* Totals */}
                <div style={{ flex: 1, padding: '5px', fontSize: '13px' }}>
                    {[
                        ['Taxable Amount', header.TaxableAmount],
                        ['CGST', header.CGSTAmount],
                        ['SGST', header.SGSTAmount],
                        ['IGST', header.IGSTAmount],
                        ['Round Off', header.RoundOff],
                    ].map(([label, val]) => (
                        <div key={label} style={{ display: 'grid', gridTemplateColumns: '115px 10px 100px', alignItems: 'center', marginBottom: '2px' }}>
                            <div style={{ fontWeight: 'bold' }}>{label}</div>
                            <div style={{ textAlign: 'center' }}>:</div>
                            <div style={{ textAlign: 'right' }}>{parseFloat(val || 0).toFixed(2)}</div>
                        </div>
                    ))}
                    <div style={{ display: 'grid', gridTemplateColumns: '115px 10px 100px', alignItems: 'center', marginTop: '5px', borderTop: border, paddingTop: '4px', fontWeight: 'bold' }}>
                        <div>Grand Total</div>
                        <div style={{ textAlign: 'center' }}>:</div>
                        <div style={{ textAlign: 'right' }}>{parseFloat(header.TotalAmount || 0).toFixed(2)}</div>
                    </div>
                </div>
            </div>

            {/* Amount in Words */}
            <div style={{ borderTop: border, padding: '4px' }}>
                <AmountInWords amount={header.TotalAmount} />
            </div>

            {/* Signature */}
            <div style={{ borderTop: border, padding: '10px 5px', fontSize: '13px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', textAlign: 'right' }}>
                <div><strong>For {header.CompanyName}</strong></div>
                <div style={{ marginTop: '30px' }}><strong>Authorised Signatory</strong></div>
            </div>

            <style>{`
                @media print {
                    @page { margin: 10px; size: A4; }
                    body { margin: 0; }
                    div { page-break-inside: avoid; }
                }
            `}</style>
        </div>
    );
};

export default PurchaseOrderBill;
